export * from './desktopNavigation'
export * from './mobileNavigation'

export { default as Header } from './header'



// WEBPACK FOOTER //
// ./src/modules/header/index.js